import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchOptions = () => axios.get(`${API}/options`).then((r) => r.data);
export const fetchStones = (params) => axios.get(`${API}/stones`, { params }).then((r) => r.data);
export const createEnquiry = (data) => axios.post(`${API}/enquiries`, data).then((r) => r.data);
export const fetchEnquiries = (key) =>
  axios.get(`${API}/enquiries`, { headers: { "x-admin-key": key } }).then((r) => r.data);
